import React from 'react';
import Button from '~/components/Button';
import SectionHeader from '~/components/SectionHeader';
import { Module } from '~/data/models/yearbook';
import { ModalScreenLayout } from '~/screens/style';
import { t } from '~/utils/i18n';
import { ScrollView, Image, Text, ButtonContent } from './style';

type ModuleDetailLayoutProps = {
  module?: Module | null;
  viewOnly?: boolean;
  loading: boolean;
  onBack: () => void;
  onAddModule: () => void;
};

export default function ModuleDetail({
  module,
  viewOnly = false,
  loading,
  onBack,
  onAddModule,
}: ModuleDetailLayoutProps): JSX.Element {
  return (
    <ModalScreenLayout
      backButtonTestID={'buttonBack'}
      title={module?.name || ''}
      onBackPress={onBack}
    >
      <ScrollView showsVerticalScrollIndicator={false}>
        <Image source={{ uri: module?.image || undefined }} />
        <SectionHeader title={t('g.aboutThisModule')} sub />
        <Text>{module?.description || ''}</Text>
        <SectionHeader title={t('g.features')} sub />
        <Text>{module?.features?.join('\n')}</Text>
        {!viewOnly && (
          <ButtonContent>
            <Button
              testID={'buttonAddModule'}
              text={t('g.addModuleToYearbook')}
              loading={loading}
              flex
              onPress={onAddModule}
            />
          </ButtonContent>
        )}
      </ScrollView>
    </ModalScreenLayout>
  );
}
